import { getIdFromToken } from './get-id-from-token';
export var replaceUrlTokens = function (tokenRegexp, tokenType, group, html, generateUrl) {
    var tokens = html.match(tokenRegexp);
    if (!tokens) {
        return html;
    }
    var tokenIds = tokens.map(getIdFromToken);
    var augmentedHtml = html;
    tokenIds.forEach(function (tokenId) {
        augmentedHtml = augmentedHtml.replace("[" + tokenType + "|" + tokenId + "]", generateUrl(group, tokenId, true));
    });
    return augmentedHtml;
};
